import Swal from 'sweetalert2';
import { get_token, get_user_details } from "@/router";
import DisscussionComment from '@/components/DisscussionComment/DiscussionComment.vue';
import Sidebar from '@/components/Sidebar/SidebarView.vue';
import Navbar from '@/components/Navbar/NavbarView.vue';
import InactivityModal from '@/components/InactivityTracker/InactivityTracker.vue';

export default {
  components: {
    DisscussionComment,
    Sidebar,
    Navbar,
    InactivityModal,
  },
  data() {
    return ({
      topic_name: '',
      description: '',
      disscussion_topics: [],
      comment_modal_visible: false,
      report_data: null,
      editTopicData: {
        topic_id: null,
        title: '',
        description: ''
      },
      user_details: {},
      errors: {},
      selected_category: null,
      showDiscussionForm: false,
      showEditTopicForm: false,
      maxLength : 150,
      expandedTopics: [],
    })
  },
  mounted() {
    this.user_details = get_user_details();
    const group_id = this.$route?.params?.group_id;
    if (group_id) {
      this.filter_group_discussions(group_id);
    }else {
      this.fetch_discussion_topics();
    }

  },
  methods: {
    open_discussion_form() {
      this.showDiscussionForm = true;
    },

    cancel_edit_topic() {
      this.showEditTopicForm = false;
      this.editTopicData = { title: "", description: "", topic_id: null };
    },

    close_discussion_form() {
      this.showDiscussionForm = false;
      this.topic_name = "";
      this.description = "";
      this.errors = {};
    },
    getToken() {
      return get_token();
    },

    create_discussion_topic_context() {
      const group_id = this.$route?.params?.group_id;
      if (group_id) {
        return this.create_group_discussion_topic();
      }
      return this.create_discussion_topic();
    },

    validate_discussion_topic() {
      this.errors = {};
      let isValid = true;
      if (!this.topic_name.trim()) {
        this.errors.topic_name = "Please select a topic.";
      }
      if (!this.description.trim()) {
        this.errors.description = "Description is required.";
        isValid = false;
      }
      return isValid;
    },
    create_discussion_topic() {
      this.description = this.$refs.quillDiscussionsEditorRef.getHTML();
      this.description = this.description.replace(/<\/?p>/g, '').trim();

      if (!this.description || this.description === '<br>' || this.description === '<br/>') {
        this.description = '';
      }
      if (!this.validate_discussion_topic()) {
        return;
      }
      $.ajax({
        type: 'POST',
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_topic/`,
        data: JSON.stringify({
          title: this.topic_name,
          description: this.description,
          portal_id: this.$route.params.portal_id,
          category_id: this.selected_category
        }),
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        contentType: 'application/json',
        success: (response) => {
          if (response?.status === "success" && response?.data?.id) {
            this.disscussion_topics.unshift(response.data);
            this.topic_name = '';
            this.description = '';

            this.$nextTick(() => {
              this.topic_name = '';
              this.description = '';
              if (this.$refs.quillDiscussionsEditorRef) {
                this.$refs.quillDiscussionsEditorRef.setHTML('');
              }

              $('#create_discussion').modal('hide');

            });
          }
        },
        complete: () => {
          this.isSubmitting = false;
        }
      });
    },

    create_group_discussion_topic() {
      this.description = this.$refs.quillDiscussionsEditorRef.getHTML();
      this.description = this.description.replace(/<\/?p>/g, '').trim();

      if (!this.description || this.description === '<br>' || this.description === '<br/>') {
        this.description = '';
      }

      if (!this.validate_discussion_topic()) {
        return;
      }

      $.ajax({
        type: 'POST',
        url: `${process.env.VUE_APP_BACKEND_API_URL}/group_management/create_group_discussion/`,
        data: JSON.stringify({
          title: this.topic_name,
          description: this.description,
          group_id: this.$route.params.group_id,
          category_id: this.selected_category
        }),
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        contentType: 'application/json',
        success: (response) => {
          if (response?.status === "success" && response?.data?.id) {
            this.disscussion_topics.unshift(response.data);
            this.topic_name = '';
            this.description = '';

            this.$nextTick(() => {
              this.topic_name = '';
              this.description = '';
              if (this.$refs.quillDiscussionsEditorRef) {
                this.$refs.quillDiscussionsEditorRef.setHTML('');
              }
              this.close_discussion_form();

            });
          }
        },
        complete: () => {
          this.isSubmitting = false;
        }
      });
    },
    fetch_discussion_topics() {
      const requestData = {
        portal_id: this.$route.params.portal_id
      };

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_portal_topics/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(requestData),
        success: (response) => {
          var status = response.status
          if (status == "success") {
            this.disscussion_topics = response.data
            Swal.close()
          }

        },

        complete: () => {
          this.isLoading = false;
          Swal.close()
        }
      });
    },
    filter_group_discussions() {
      const requestData = {
        group_id: this.$route.params.group_id
      };

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/group_management/filter_group_discussions/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(requestData),
        success: (response) => {
          var status = response.status
          if (status == "success") {
            this.disscussion_topics = response.data
            Swal.close()
          }

        },

        complete: () => {
          this.isLoading = false;
          Swal.close()
        }
      });
    },
    display_comment_modal(report_data) {
      this.report_data = report_data;
      this.comment_modal_visible = true;
    },

    edit_topic(topic) {
      this.showEditTopicForm = true;     // show the inline edit panel
      this.editTopicData.topic_id = topic.id;
      this.editTopicData.title = topic.name;
      this.editTopicData.description = topic.description || '';
      this.$nextTick(() => {
        if (this.$refs.quillDiscussionsUpdateEditorRef) {
          this.$refs.quillDiscussionsUpdateEditorRef.setHTML(this.editTopicData.description);
        }
      });
    },

    save_topic_edits() {
      this.editTopicData.description = this.$refs.quillDiscussionsUpdateEditorRef.getHTML();
      this.editTopicData.description = this.editTopicData.description.replace(/<\/?p>/g, '').trim();
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/update_topic/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({
          topic_id: this.editTopicData.topic_id,
          title: this.editTopicData.title,
          description: this.editTopicData.description
        }),
        success: (response) => {
          if (response?.status === "success" && response?.data) {
            const updated = response.data;

            // Update local array
            this.disscussion_topics = this.disscussion_topics.map(topic =>
              topic.id === updated.id ? updated : topic
            );

            Swal.close();
            this.showEditTopicForm = false;
            // Reset modal fields after DOM updates
            this.$nextTick(() => {
              this.editTopicData = {
                topic_id: null,
                title: "",
                description: ""
              };

              if (this.$refs.quillDiscussionsUpdateEditorRef) {
                this.$refs.quillDiscussionsUpdateEditorRef.setHTML("");
              }

              this.errors = {};
            });
          }
        }
      });
    },

    delete_topic(topic_id) {
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_topic/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({ topic_id: topic_id }),
        success: (response) => {
          var status = response.status
          if (status == "success") {
            this.disscussion_topics = this.disscussion_topics.filter(topic => topic.id !== topic_id);
          }
        },
      });
    },
    hide_comment() {
      this.comment_modal_visible = false;
    },
    toggleDescription(topicId) {
      if (this.isExpanded(topicId)) {
        this.expandedTopics = this.expandedTopics.filter(id => id !== topicId);
      } else {
        this.expandedTopics.push(topicId);
      }
    },
   isExpanded(topicId) {
      return this.expandedTopics.includes(topicId);
    },
    displayedDescription(topic) {
    if (!topic.description) return '';

    // Show full description if expanded or shorter than maxLength
    if (this.isExpanded(topic.id) || topic.description.length <= this.maxLength) {
      return topic.description;
    }

    // Truncate and add ellipsis
    return topic.description.slice(0, this.maxLength) + '...';
  },

  },
}